const ourAttorneysBlock = {
  $blocks: document.querySelectorAll('section.our_attorneys_block'),
  currScrollerTimeScale: 1,
  maxScrollerTimeScale: 0.7,
  maxScrollDeltaY: 100,
  init() {
    if (this.$blocks.length) {
      this.processBlocks();
      this.setUpListeners();
    }
  },

  processBlocks() {
    this.$blocks.forEach($block => {
      if ($block.classList.contains('template_scrolling')) {
        this.setUpScrollers($block);
      }
    });
  },

  setUpListeners() {
    window.addEventListener('scroll', this.scrollHandler.bind(this));

    this.$blocks.forEach($block => {
      if (window.innerWidth <= 768
      && $block.classList.contains('template_grid')) {
        $block
          .querySelector('.mobile_load_more')
          .addEventListener('click', ({currentTarget}) => {
            currentTarget
              .closest('.grid_wrapper')
              .classList.add('loaded');
          });
      }
    });
  },

  lastScrollTop: 0,
  scrollDeltaY: 0,
  scrollTimeout: null,
  scrollHandler() {
    clearTimeout(this.scrollTimeout);

    this.scrollTimeout = setTimeout(() => {
      this.calcScrollVars();
      this.updateScrollerAnims();
    }, 100);

    this.calcScrollVars();
    this.updateScrollerAnims();
  },

  calcScrollVars() {
    const currentScrollTop = document.documentElement.scrollTop;
    this.scrollDeltaY = (currentScrollTop - this.lastScrollTop) / this.maxScrollDeltaY;

    if (this.scrollDeltaY > 1) {
      this.scrollDeltaY = 1;
    } else if (this.scrollDeltaY < -1) {
      this.scrollDeltaY = -1;
    }

    this.lastScrollTop = currentScrollTop;
  },

  updateScrollerAnims() {
    this.$blocks.forEach($block => {
      if ($block.classList.contains('template_scrolling')) {
        const $rows = $block.querySelectorAll('.row_wrapper');

        if ($rows.length) {
          $rows.forEach(($row, id) => {
            // const newScale = 1 - (this.maxScrollerTimeScale * Math.abs(this.scrollDeltaY));

            // console.log(newScale);

            // gsap.to($row.animObj, {
            //   duration: 5,
            //   timeScale: newScale,
            //   ease: 'power1.inOut'
            // });
          });
        }
      }
    });
  },

  setUpScrollers($block) {
    const $rows = $block.querySelectorAll('.row_wrapper');

    if ($rows.length) {
      $rows.forEach(($row, id) => {
        const rowWidth = $row.querySelector('.row').scrollWidth;
        const $rowClone = $row.querySelector('.row').cloneNode(true);
        let animSettings = {
          ease: 'none',
          repeat: -1
        };

        if (id % 2 === 0) {
          $row.append($rowClone);
          animSettings.x = '-' + rowWidth + 'px';
          animSettings.duration = 50;
        } else {
          $row.prepend($rowClone);
          animSettings.x = rowWidth + 'px';
          animSettings.duration = 30;
        }

        $row.animObj = gsap.to($row, animSettings);
      });
    }
  }
};

ourAttorneysBlock.init();
